<template>
    <div class="TemplateTab p-3">
        <div class="SearchArea">
            <input type="search" @input="onChange($event)" :value="selectedValue"
                class="form-control rounded-pill h-45px" placeholder="Search ... " />
        </div>
        <div class="imagsGallery">
            <h5 class="text-muted py-2">Photos</h5>
            <!-- <div class="wrapperDiv addpositionRelative" v-if="isImagesLoading === true">
                <div class="imageLoader ">
                 <LoaderSpinner></LoaderSpinner>
                </div> 
            </div> -->
            <!-- <div @scroll="handleScroll" :class="`showImgs containerimg  ${isImagesLoading === true ? 'hidevisibility' : ''}`" id="masonry-grid"> -->
            <div @scroll="handleScroll" :class="`showImgs containerimg  `" id="masonry-grid">
                <!-- <div class="grid-sizer"></div> -->

                <a ref="column" :draggable="true" @dragstart="dragElement($event, item.urls.regular)"
                    href="javascript:;" @click="addImageinCanvas(item.urls.regular, index)" class="column"
                    v-for="(item, index) of imglist" v-bind:key="index">
                    <img @load="handleLoad" crossorigin="anonymous" class="" :src="`${item.urls.thumb}`" alt="" />
                </a>
            </div>

        </div>
    </div>
</template>

<script>
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
// import Masonry from "masonry-layout";
// import LoaderSpinner from "../../utils/TabLoader.vue";
import { debounce } from "lodash";

export default {
    name: "PhotosTab",
    data() {
        return {
            imglist: [],
            isImagesLoading: true,
            currentPage: 0,
            searchCurrentPage: 0,
            selectedValue: '',
            API_KEY: 'iFLIyHbCStygurU87Lb-RmEPP79dJzUfEJ5po0W0NB4',
            imageLoadCount: 0,
            debouncedSearch: debounce(this.searchData, 500),
        }
    },
    components: {
        // LoaderSpinner
    },
    mounted() {
        this.getImgs();

    },
    computed: {
        getActiveCanvas() {
            return this.$store.getters.getCurrentActiveCanvas
        },
    },

    methods: {
        handleLoad() {
            this.imageLoadCount++;
            // if(this.imageLoadCount === this.imglist.length) {
            //     this.initmasnory();
            // }
        },
        onChange(e) {
            let value = e.target.value;
            this.selectedValue = value;
            if (value === '') {
                this.imglist = [];
                this.searchCurrentPage = 0
            }
            this.debouncedSearch(value);
        },
        searchData(query) {
            console.log(query)
            if (query === "") {
                this.getImgs();
            } else {

                this.searchImages(query)
            }
        },
        handleScroll() {
            const container = this.$el.querySelector("#masonry-grid");
            const scrollPosition = container.scrollTop + container.clientHeight;
            const totalHeight = container.scrollHeight;

            // Adjust the threshold as needed
            if (scrollPosition >= totalHeight - 200) {
                // Fetch more images when the user is near the bottom
                if (this.selectedValue === '') {

                    this.getImgs();
                } else {
                    this.searchImages(this.selectedValue)
                }
            }
        },

        //    initmasnory(){
        //     var grid = document.querySelector('#sss-grid');
        //     new Masonry(grid, {
        //         // options...
        //         columnWidth: '.grid-sizer',
        //         itemSelector: '.column',
        //         percentPosition: true,
        //         gutter: 10

        //     });
        //     this.isImagesLoading = false;

        //    },
        searchImages(query) {
            // this.isImagesLoading = true;
            this.searchCurrentPage++;

            var URL = "https://api.unsplash.com/search/photos?client_id=" + this.API_KEY + '&query=' + query + '&per_page=50' + '&page=' + this.searchCurrentPage;
            let self = this;
            axios({
                method: 'get',
                url: URL,
            })
                .then(function (response) {
                    if (self.searchCurrentPage === 1) {
                        self.imglist = [...response.data.results];
                    } else {
                        self.imglist = [...self.imglist, ...response.data.results];
                    }

                    // self.imglist = response.data;
                    console.log(response)
                    // self.$nextTick(function () {
                    // //    setTimeout(() => {
                    //      self.initmasnory();
                    // //    }, 1500);

                    // })

                });
        },
        getImgs() {
            // this.isImagesLoading = true;
            this.currentPage++;

            var URL = "https://api.unsplash.com/photos/?client_id=" + this.API_KEY + '&page=' + this.currentPage + '&per_page=50';
            let self = this;
            axios({
                method: 'get',
                url: URL,
            })
                .then(function (response) {
                    self.imglist = [...self.imglist, ...response.data];
                    // self.imglist = response.data;
                    console.log(response)
                    // self.$nextTick(function () {
                    // //    setTimeout(() => {
                    //      self.initmasnory();
                    // //    }, 1500);

                    // })

                });

        },
        dragElement(e, link) {
            let obj = {
                id: `Photos_${uuidv4()}`,
                type: 'img',
                // top:250,
                // left:150,
                rotate: 0,
                top: 0,
                left: 0,
                scaleX: 1,
                scaleY: 1,
                zoom: 1,
                // width:150,
                // height:100,
                width: this.getActiveCanvas.size.width,
                height: this.getActiveCanvas.size.height,
                opacity: 1,
                lock: false,
                borderRadius: 0,
                url: link,
                brightness: 100,
                contrast: 100,
                saturation: 100,
                animationClassIn: "",
                animationClassOut: "",
                animationClassLoop: "",
                animationClass: "",
                animationDelay: 0,
                animationDuration: 2,
                animationDelayIn: 0,
                animationDurationIn: 2,
                animationDelayOut: 0,
                animationDurationOut: 2,
                animationLoopDuration: 2,
                orientation: 0,
                adjustment: 'cover',
                animationLoop: false
            };
            var j = JSON.stringify(obj);
            e.dataTransfer.setData("imgs", j);
        },
        addImageinCanvas(link) {
            const newImage = {
                id: `Photos_${uuidv4()}`,
                type: 'img',
                top: 0,
                rotate: 0,
                left: 0,
                scaleX: 1,
                scaleY: 1,
                zoom: 1,
                width: this.getActiveCanvas.size.width,
                height: this.getActiveCanvas.size.height,
                opacity: 1,
                lock: false,
                borderRadius: 0,
                url: link,
                brightness: 100,
                contrast: 100,
                saturation: 100,
                isInAnimationActive: false,
                isOutAnimationActive: false,
                isLoopAnimationActive: false,
                AnimationSequence: [],
                animationClassIn: "",
                animationClassOut: "",
                animationClass: "",
                animationClassLoop: "",
                animationDelay: 0,
                animationDuration: 2,
                animationDelayIn: 0,
                animationDurationIn: 2,
                animationDelayOut: 0,
                animationDurationOut: 2,
                animationLoopDuration: 2,
                orientation: 0,
                adjustment: 'cover',
                animationLoop: false
            };

            this.$store.dispatch("addObjectInCanvas", newImage).then(() => {
                this.$nextTick(() => {
                    const newElement = document.querySelector(`[data-id-t="${newImage.id}"]`);
                    if (newElement) {
                        this.$store.dispatch("setActiveObject", {
                            target: newElement,
                            id: newImage.id
                        });
                    }
                });
            });
        }
    },

}
</script>
<!-- <style scoped>
    .containerimg{
        height: 95vh;
    overflow-y: scroll;
    }
#flexbox {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.column {
  flex: 50%;
  max-width: 50%;
  padding: 0 4px;
}

.column img , .column a  {
  vertical-align: middle;
  margin-top: 8px;
  width: 100%;

}

.column:nth-child(even) {
  display: flex;
  flex-direction: column-reverse;
}
</style> -->
<!-- <style scoped>
.containerimg {
    height: 95vh;
    overflow-y: scroll;
}
#flexbox {
    display: flex;
    flex-wrap: wrap;
    padding: 0 4px;
}

.column {
    flex: 0 0 50%; /* adjust as needed */
    max-width: 50%;
    padding: 0 4px;
}

.column img {
    width: 100%;
    height: auto; /* ensure aspect ratio is maintained */
    display: block;
    margin-top: 8px;
}
</style> -->


<!-- <style scoped>
.containerimg {
  display: flex;
  flex-wrap: wrap;
}

#masonry-grid {
  column-count: 2;
  column-gap: 10px; /* adjust as needed */
}

.column {
  break-inside: avoid;
  margin-bottom: 10px;
}

.column div {
  break-inside: avoid;
}

.column img {
  width: 100%;
  display: block;
  border-radius: 5px;
}
</style> -->
<style scoped>
/* .containerimg {
  display: flex;
  flex-wrap: wrap;
} */
.containerimg {
    /* height: 95vh !important; */
    height: calc(100vh - 258px) !important;

    overflow-y: scroll;
}

.column {
    width: 100%;
    /* Adjust as needed */
    box-sizing: border-box;
    padding: 5px;
    /* Adjust as needed */
    display: block;
}

.grid-sizer {
    width: 50%;
}

.column img {
    width: 100%;
    height: auto;
    border-radius: 5px;
}

.addPositionAbsolute {
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.addpositionRelative {
    position: relative;
    height: 100vh;
}

.imageLoader {
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.imagsGallery {
    position: relative;
}

.hidevisibility {
    visibility: hidden;
    position: fixed;
    top: 0;
}
</style>